// GetCoins returns global data for coins
export const CoinsService_GetCoinsLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_GetCoins);
CoinsService_GetCoinsLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetCoins" as const;

// GetCoinsHistory returns coins history sections (e.g. transactions)
export const CoinsService_GetCoinsHistoryLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_GetCoinsHistory);
CoinsService_GetCoinsHistoryLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetCoinsHistory" as const;

// GetCoinsHistoryHeader returns data for rendering a coins history header
export const CoinsService_GetCoinsHistoryHeaderLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_GetCoinsHistoryHeader);
CoinsService_GetCoinsHistoryHeaderLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetCoinsHistoryHeader" as const;

// GetCoinsHistoryTransactionByOrderId returns a coins history transaction by order id
export const CoinsService_GetCoinsHistoryTransactionByOrderIdLazy = () =>
  import("./service.grpc").then(
    (m) => m.CoinsService_GetCoinsHistoryTransactionByOrderId
  );
CoinsService_GetCoinsHistoryTransactionByOrderIdLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetCoinsHistoryTransactionByOrderId" as const;

// GetMissionsHistory returns history of missions
export const CoinsService_GetMissionsHistoryLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_GetMissionsHistory);
CoinsService_GetMissionsHistoryLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetMissionsHistory" as const;

// SubmitMissionProgress submits a missions progress to CRM
export const CoinsService_SubmitMissionProgressLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_SubmitMissionProgress);
CoinsService_SubmitMissionProgressLazy.method =
  "aysa_api.services.coins.v1.CoinsService/SubmitMissionProgress" as const;

// GetActiveMissions returns the currently open missions that are displayed in the account area
export const CoinsService_GetActiveMissionsLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_GetActiveMissions);
CoinsService_GetActiveMissionsLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetActiveMissions" as const;

// ClaimMissionReward claims a mission reward
export const CoinsService_ClaimMissionRewardLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_ClaimMissionReward);
CoinsService_ClaimMissionRewardLazy.method =
  "aysa_api.services.coins.v1.CoinsService/ClaimMissionReward" as const;

// GetMissionStatusOverview returns data for rendering the Status Overview page
export const CoinsService_GetMissionStatusOverviewLazy = () =>
  import("./service.grpc").then((m) => m.CoinsService_GetMissionStatusOverview);
CoinsService_GetMissionStatusOverviewLazy.method =
  "aysa_api.services.coins.v1.CoinsService/GetMissionStatusOverview" as const;
